import { Locale } from '../locale'
import './months'
import './weekdays'

Locale.getInstance().registerKeySet('en', 'general', {
  languages: {
    en: 'English',
    fr: 'French',
  },
  previous: 'Previous',
  next: 'Next',
  yes: 'Yes',
  no: 'No',
  ok: 'OK',
  choose: 'Choose',
  required: 'Required',
  cancel: 'Cancel',
  close: 'Close',
  reset: 'Reset',
  save: 'Save',
  login: 'Login',
  logout: 'Logout',
  loading: 'Loading',
  register: 'Register',
  modify: 'Change',
  finish: 'Finish',
  proceed: 'Continue',
  apply: 'Apply',
  clear: 'Clear',
  virtualPlace: 'Virtual place',
  or: 'or',
  selectAll: 'Select all',
  deselectAll: 'Deselect all',
  unsavedChanges: 'You have unsaved information, do you still want to leave this page',
})

Locale.getInstance().registerKeySet('fr', 'general', {
  languages: {
    en: 'Anglais',
    fr: 'Français',
  },
  previous: 'Précédent',
  next: 'Suivant',
  yes: 'Oui',
  no: 'Non',
  ok: 'OK',
  choose: 'Choisir',
  required: 'Requis',
  cancel: 'Annuler',
  close: 'Fermer',
  reset: 'Réinitialiser',
  save: 'Sauvegarder',
  login: 'Connexion',
  logout: 'Déconnexion',
  loading: 'Chargement',
  register: 'Inscription',
  modify: 'Modifier',
  finish: 'Terminer',
  proceed: 'Continuer',
  apply: 'Appliquer',
  clear: 'Effacer',
  virtualPlace: 'Place Virtuelle',
  or: 'ou',
  selectAll: 'Sélectionner tout',
  deselectAll: 'Désélectionner tout',
  unsavedChanges:
    'Vous avez des informations non-sauvegardées, voulez-vous quand même quitter cette page?',
})

// Path: general.ts
